import { createContext } from 'react';

import type { ConnectModalState } from './types';

export const ConnectModalContext = createContext({} as ConnectModalState);
